import SEO from './SEO';

const NotFoundSEO = () => {
  return (
    <SEO
      title="Page Not Found - 404 Error"
      description="The page you are looking for could not be found. Please check the URL or navigate back to our homepage for medical supplies and healthcare solutions in Erbil, Iraq."
      keywords="404 error, page not found, medical supplies Erbil Iraq, healthcare solutions"
      url="https://nabazatalqalb.com/404"
    />
  );
};

export default NotFoundSEO; 